import { isProd } from '@lib/utils';
import axios from 'axios';

export enum SkuCode {
  // 一周
  'w1' = 'w1',

  // 一个月
  'm1' = 'm1',

  // 三个月
  'm3' = 'm3',

  // 半年
  'm6' = 'm6',

  // 一年
  'm12' = 'm12',

  // 永久买断
  'forever' = 'forever',
}

// ETH 2900
export const skuEthPriceMap: Record<SkuCode, number> = {
  [SkuCode.w1]: 0.015,
  [SkuCode.m1]: 0.027,
  [SkuCode.m3]: 0.08,
  [SkuCode.m6]: 0.13,
  [SkuCode.m12]: 0.23,
  [SkuCode.forever]: 0.32,
};

// ETH 1820
// export const skuEthPriceMap: Record<SkuCode, number> = {
//   [SkuCode.w1]: 0.03,
//   [SkuCode.m1]: 0.07,
//   [SkuCode.m3]: 0.15,
//   [SkuCode.m6]: 0.23,
//   [SkuCode.m12]: 0.32,
//   [SkuCode.forever]: 0.4,
// };

export const DEPOSIT_ADDRESS = isProd
  ? '0xcBf641a213E742f60DEBa3bF5ae4ee87cA295Bd5' // Account 2
  : '0x382f0015e395844a528f34bd77B1Ca40eeC4bdbF'; // Account 3

export const DEPOSIT_CHAIN_ID = isProd ? 1 : 4; // 生产环境以太主网，开发环境 Rinkeby

export interface ISkuMeta {
  skuCode: SkuCode;
  name: string;
  ethPrice: number;
}

// 前端根据这个显示 sku 列表，临时增删 sku 改这里就行
export const skuMetaList: Array<ISkuMeta> = [
  //   {
  //     skuCode: SkuCode.w1,
  //     name: '一周',
  //     ethPrice: skuEthPriceMap[SkuCode.w1],
  //   },
  {
    skuCode: SkuCode.m1,
    name: '1个月',
    ethPrice: skuEthPriceMap[SkuCode.m1],
  },
  //   {
  //     skuCode: SkuCode.m3,
  //     name: '3个月',
  //     ethPrice: skuEthPriceMap[SkuCode.m3],
  //   },
  //   {
  //     skuCode: SkuCode.m6,
  //     name: '6个月',
  //     ethPrice: skuEthPriceMap[SkuCode.m6],
  //   },
  {
    skuCode: SkuCode.m12,
    name: '12个月',
    ethPrice: skuEthPriceMap[SkuCode.m12],
  },
  {
    skuCode: SkuCode.forever,
    name: '永久',
    ethPrice: skuEthPriceMap[SkuCode.forever],
  },
];

const commissionRate = 0.15;

export async function computeUsdtBonus(skuCode: SkuCode): Promise<number> {
  try {
    const skuEthPrice = skuEthPriceMap[skuCode];
    const USDT_ETH_PRICE: number = await getRealTimeEthPrice();
    // 把ETH转换成USDT，再计算提成
    return Math.floor(skuEthPrice * USDT_ETH_PRICE * commissionRate) || 0;
  } catch (err) {
    console.error('[computeUsdtBonus] 计算提成金额出现错误：', err);
    return 0;
  }
}

const FALLBACK_USDT_ETH_PRICE = 2000;

function getRealTimeEthPrice(): Promise<number> {
  return axios
    .get(
      'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD&api_key=36d4c7ebf0adcac41647fdd1334501015a70b977d6577427046a62c08a2a2c23',
    )
    .then((res) => {
      const data = res.data;
      const usd = data.USD;
      if (!usd) {
        console.error('[getRealTimeEthPrice] 获取USDT/ETH汇率失败，使用默认值');
        return FALLBACK_USDT_ETH_PRICE;
      } else {
        return usd;
      }
    })
    .catch((err) => {
      console.error('[getRealTimeEthPrice] 获取USDT/ETH汇率失败', err);
      return FALLBACK_USDT_ETH_PRICE;
    });
}
